"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _progressStep = _interopRequireDefault(require("./progress-step.scss"));

var ProgressStep = function ProgressStep(_ref) {
  var label = _ref.label,
      isCurrent = _ref.isCurrent,
      disabled = _ref.disabled,
      Link = _ref.element,
      step = (0, _objectWithoutProperties2["default"])(_ref, ["label", "isCurrent", "disabled", "element"]);
  var wrapperProps = {
    className: (0, _classnames["default"])(isCurrent ? _progressStep["default"].StepCurrent : _progressStep["default"].Step, (0, _defineProperty2["default"])({}, _progressStep["default"].StepDisabled, disabled))
  };

  var progressStepContent = _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("span", {
    className: _progressStep["default"].stepIndex
  }), _react["default"].createElement("span", {
    className: _progressStep["default"].stepLabel
  }, label));

  return !disabled ? _react["default"].createElement(Link, (0, _extends2["default"])({}, wrapperProps, step), progressStepContent) : _react["default"].createElement("span", wrapperProps, progressStepContent);
};

ProgressStep.defaultProps = {
  element: 'a'
};
var _default = ProgressStep;
exports["default"] = _default;